import ThreadsService from '@/services/ThreadsService.js';
import PinService from '@/services/PinService';
import MarkerClusterer from '@google/markerclustererplus';
import Vue from 'vue';

import { MARKER_ICONS } from '@/constants/gmaps.js';
import { PINS_ATTACHMENTS_URL } from '@/constants/global.js';
import { createPolyline } from '@/utils/helpers.js';

export const namespaced = true;

const markerOnClickHandler = (dispatch, marker, layer) => {
  // Set layer && layer pin <detail> to display as active
  dispatch(
    'layers/toggleOpenLayerPinInURL',
    [marker.drawingId, 'layer', true],
    {
      root: true
    }
  );
  dispatch('layers/toggleOpenLayerPinInURL', [marker.id, 'pin', true], {
    root: true
  });

  // Set content and open infowindow
  let markerImage = '';
  if (marker.image) {
    markerImage = `<img
      src="${PINS_ATTACHMENTS_URL}${marker.image}"
      alt="${marker.title}"
    />`;
  }

  let markerTitle = '';
  if (marker.title) {
    markerTitle = `<b>${marker.title}</b><br>`;
  }

  let markerFiles = '';
  if (marker.attachments) {
    for (let file in marker.attachments) {
      markerFiles =
        markerFiles +
        `<a href=" ${PINS_ATTACHMENTS_URL}${marker.attachments[file].filePath}" target="_blank">Příloha</a>&nbsp;&nbsp;`;
    }
  }
  // if (marker.file) {
  //   markerFiles =
  //     markerFiles +
  //     '<a href="' +
  //     PINS_ATTACHMENTS_URL +
  //     marker.file +
  //     '" target="_blank">Příloha</a>&nbsp;&nbsp;'
  // }
  // if (marker.file2) {
  //   markerFiles =
  //     markerFiles +
  //     '<a href="' +
  //     PINS_ATTACHMENTS_URL +
  //     marker.file2 +
  //     '" target="_blank">Příloha 2</a>&nbsp;&nbsp;'
  // }
  // if (marker.file3) {
  //   markerFiles =
  //     markerFiles +
  //     '<a href="' +
  //     PINS_ATTACHMENTS_URL +
  //     marker.file3 +
  //     '" target="_blank">Příloha 3</a>'
  // }

  let detailButton = '';
  if (marker.title && marker.text_detail) {
    detailButton = ` <button style="padding-bottom: 5px" onclick="toggleLayerPinDetail(${marker.id})">Detail</button>`;
  }

  /*let markerText =
  '<div>' +
  marker.text +
  '<br> <button @click="vm.$refs.layer-pin-detail.toggleModal()">Detail</button>' +
  '<br>' +
  markerFiles +
  '</div>'*/

  let supportWrapper = '';
  if (
    state.pinTypes[marker.pinTypeId] &&
    state.pinTypes[marker.pinTypeId].voting_allowed == 1
  ) {
    supportWrapper = `
      <div>Podpořilo <strong>${marker.supportersCounter}</strong></div>
      <button class="btnStyled support" onclick="supportPin(${marker.id}, ${marker.drawingId})"><i class="far fa-thumbs-up"></i> Podpořit</button>
    `;
  }

  let actionsWrapper = `
    <br />
    <br />
    ${detailButton}
    <div style="display:flex; flex-flow:row; align-items:center; justify-content: space-between;">
      ${supportWrapper}
    </div>
    <br>
    `;

  let editButton = `<button class="btnStyled edit" onclick="openEditView(${marker.id})"><i class="far fa-edit"></i> Upravit</button>`;
  let deleteButton = `<button class="btnStyled delete" onclick="deletePin(${marker.id},  ${marker.drawingId})"><i class="far fa-trash-alt"></i> Smazat</button>`;

  let actionButtons = `
    <div style="display:flex; flex-flow:row; align-items:center; justify-content: space-between; border-top: 0.5px solid lightgrey; padding-top: 5px;">
    ${editButton}
    ${deleteButton}
    </div>`;

  if (marker.permissions.canEdit) {
    actionsWrapper = actionsWrapper + actionButtons;
  }

  let markerText = `<div class="pinDetailBox">
      ${markerTitle}
      <i>Vrstva: ${layer.name}</i>
      ${markerImage}
      <p>
        ${marker.text}
      </p>
      <br>
      ${markerFiles}
      <br>
      ${actionsWrapper}
    </div>`;
  dispatch('general/setContentAndOpenInfowindow', [markerText, marker], {
    root: true
  });
};

export const state = {
  threadList: [], // List of threads from API
  markers: [], // Markers of threads on GM
  markersVisible: true, // Are markers of threads visible?
  markersLayered: [], // Markers linked-attached to layer
  cluster: null, // Store for Marker Cluster (to be able to destroy and make a new one /reload/ that later)
  attachedPinsList: [], // List of markers attached to layer from API
  fetchedPinLayers: [], // Store IDs of already fetched layers (Pins-Markers attached to layers)
  pinTypes: [], // Pin types
  fetchedPinTypes: [] // Store IDs of pin types in use (to show in captions)
};
export const mutations = {
  UPDATE_MARKER(state, { id, ...rest }) {
    if (state.markersLayered[id]) {
      // marker is google maps Marker instance. So it has to be mutated.
      const marker = Object.assign(state.markersLayered[id], rest);

      marker.updateClickListener ? marker.updateClickListener() : undefined;

      Vue.set(state.markersLayered, id, marker);
    }
  },
  ADD_THREADS(state, threads) {
    state.threadList = threads;
  },

  ADD_GM_GLOBAL_MARKERS(state, markers) {
    state.markers = [...state.markers, ...markers];
  },

  REMOVE_GM_LAYER_MARKERS(state, markers) {
    markers.forEach((id) => {
      if (state.markersLayered[id]) {
        if (state.markersLayered[id].lines) {
          state.markersLayered[id].lines.forEach((line) => {
            line.setMap(null);
          });
        }
        state.markersLayered[id].setMap(null);
      }
    });

    state.markersLayered = state.markersLayered.filter((marker, id) => {
      return !markers.includes(id);
    });
  },

  ADD_GM_LAYER_MARKERS(state, markers) {
    markers.forEach((marker) => {
      Vue.set(state.markersLayered, marker.id, marker);
    });
  },

  HIDE_ALL_GM_GLOBAL_MARKERS(state) {
    state.markersVisible = false;
    state.markers.forEach((single) => {
      single.setMap(null);
    });
    state.cluster.clearMarkers();
  },

  SHOW_ALL_GM_GLOBAL_MARKERS(state, map) {
    state.markersVisible = true;
    state.markers.forEach((single) => {
      single.setMap(map);
    });
    state.cluster.addMarkers(state.markers);
  },

  TOGGLE_GM_MARKERS_BY_LAYER(state, markers) {
    markers.forEach((single) => {
      if (single.visible) {
        single.setVisible(false);
        if (single.lines && single.lines.length > 0) {
          single.lines.map((e) => {
            e.setVisible(false);
          });
        }
      } else {
        single.setVisible(true);
        if (single.lines && single.lines.length > 0) {
          single.lines.map((e) => {
            e.setVisible(true);
          });
        }
      }
    });
  },

  NEW_CLUSTER(state, cluster) {
    state.cluster = cluster;
  },

  RELOAD_CLUSTER(state, cluster) {
    state.cluster.setMap(null);
    state.cluster = cluster;
  },

  STORE_ATTACHED_MARKERS(state, markers) {
    state.attachedPinsList = markers;
  },

  LOG_FETCHED_MARKER_LAYER(state, layerId) {
    state.fetchedPinLayers.push(layerId);
  },

  CLOSE_ALL_GM_LAYER_MARKERS(state, markers) {
    state.markersLayered.forEach((single) => {
      single.pinOpen = false;
    });
  },

  SET_GM_LAYER_MARKER_OPEN(state, markerId) {
    state.markersLayered[markerId].pinOpen = true;
  },

  ADD_PIN_TYPE(state, pinType) {
    Vue.set(state.pinTypes, pinType.id, pinType);
  },

  ADD_ALL_PIN_TYPES(state, pinTypes) {
    Object.keys(pinTypes).forEach((key) => {
      let single = pinTypes[key];
      Vue.set(state.pinTypes, single.id, single);
    });
  },

  LOG_PIN_TYPE(state, pinTypeId) {
    if (state.fetchedPinTypes.indexOf(pinTypeId) <= -1) {
      state.fetchedPinTypes.push(pinTypeId);
    }
  }
};

export const actions = {
  fetchGlobalThreads({ commit }) {
    return ThreadsService.getAll()
      .then((response) => {
        commit('ADD_THREADS', response.data);
      })
      .catch(() => {
        console.error('Error: threads/fetchGlobalThreads() failed');
      });
  },
  updateMarker({ commit }, data) {
    commit('UPDATE_MARKER', data);
  },
  addMarkersLayer({ commit }, layerId) {
    commit('ADD_MARKERS_LAYER', layerId);
  },

  addGmMarkers({ commit }, markers) {
    commit('ADD_GM_GLOBAL_MARKERS', markers);
  },

  addGmLayerMarkers({ commit }, markers) {
    commit('ADD_GM_LAYER_MARKERS', markers);
  },

  removeGmLayerMarkers({ commit }, markers) {
    commit('REMOVE_GM_LAYER_MARKERS', markers);
  },

  toggleAllGmMarkers({ commit, rootState }) {
    if (state.markersVisible) {
      commit('HIDE_ALL_GM_GLOBAL_MARKERS');
    } else {
      let map = rootState.gmaps.map;
      commit('SHOW_ALL_GM_GLOBAL_MARKERS', map);
    }
  },

  // -------------------------------------------------------------------
  // Toggling markers attached to layer
  hideMarkersByLayer({ commit, getters, rootState, dispatch }, layerId) {
    if (state.pinTypes.length === 0) {
      ThreadsService.getAllPinTypes().then((result) => {
        let pinTypes = result.data;
        commit('ADD_ALL_PIN_TYPES', pinTypes);
      });
    }

    if (state.fetchedPinLayers.indexOf(layerId) <= -1) {
      PinService.getPins(layerId)
        .then((result) => {
          commit('LOG_FETCHED_MARKER_LAYER', layerId);

          if (result.data && result.data.length > 0) {
            const {
              Marker,
              Size,
              Point,
              Polyline
            } = rootState.gmaps.google.maps;

            let iconFin = {
              url: MARKER_ICONS['Info'],
              size: new Size(27, 43),
              origin: new Point(0, 0),
              anchor: new Point(14, 43),
              labelOrigin: new Point(14, 17)
            };
            let lmarkers = result.data.map((single) => {
              if (state.pinTypes[single.pinTypeId]) {
                if (single.visible) {
                  iconFin.url = state.pinTypes[single.pinTypeId].pin_url;
                } else {
                  iconFin.url =
                    state.pinTypes[single.pinTypeId].pin_private_url;
                }
                commit('LOG_PIN_TYPE', single.pinTypeId);
              }

              const markerDefinition = {
                id: single.id,
                position: {
                  lat: parseFloat(single.lat),
                  lng: parseFloat(single.lng)
                },
                lat: parseFloat(single.lat),
                label: '' + single.id, // Pin number
                map: rootState.gmaps.map,
                title: single.title,
                image: single.image,
                text: single.text,
                text_detail: single.text_detail,
                attachments: single.attachments,
                drawingId: single.drawingId,
                pinOpen: false,
                pinTypeId: single.pinTypeId,
                icon: iconFin,
                moreData: single.moreData,
                supportersCounter: single.supportersCounter,
                permissions: single.permissions,
                status: single.visible,
                comments: single.comments ? single.comments : [],
                optimized: false
              };

              if (single.line) {
                const polylines = [];
                if (Array.isArray(single.line) && single.line[0].lat) {
                  polylines.push(
                    createPolyline(rootState.gmaps, {
                      path: single.line
                    })
                  );
                } else {
                  Object.values(single.line).forEach((path) => {
                    polylines.push(
                      createPolyline(rootState.gmaps, {
                        path: path
                      })
                    );
                  });
                }

                markerDefinition.lines = polylines;
              }

              const marker = new Marker(markerDefinition);

              marker.addListener(`click`, () =>
                markerOnClickHandler(
                  dispatch,
                  marker,
                  rootState.layers.layers[layerId]
                )
              );

              marker.updateClickListener = function () {
                rootState.gmaps.google.maps.event.clearListeners(this, 'click');

                this.addListener(`click`, () =>
                  markerOnClickHandler(
                    dispatch,
                    this,
                    rootState.layers.layers[layerId]
                  )
                );
              };

              return marker;
            });

            commit('ADD_GM_LAYER_MARKERS', lmarkers);
          }
        })
        .catch(() => {});
    } else {
      let markers = getters.getMarkersByLayerID(layerId);
      commit('TOGGLE_GM_MARKERS_BY_LAYER', markers);
    }
  },

  addNewPin({ commit, rootState, dispatch }, single) {
    const { Marker, Size, Point, Polyline } = rootState.gmaps.google.maps;

    let iconFin = {
      url: MARKER_ICONS['Info'],
      size: new Size(27, 43),
      origin: new Point(0, 0),
      anchor: new Point(14, 43),
      labelOrigin: new Point(14, 17)
    };

    if (state.pinTypes[single.pinTypeId]) {
      if (single.visible) {
        iconFin.url = state.pinTypes[single.pinTypeId].pin_url;
      } else {
        iconFin.url = state.pinTypes[single.pinTypeId].pin_private_url;
      }
      commit('LOG_PIN_TYPE', single.pinTypeId);
    }
    const markerDefinition = {
      id: single.id,
      position: {
        lat: parseFloat(single.lat),
        lng: parseFloat(single.lng)
      },
      lat: parseFloat(single.lat),
      label: '' + single.id,
      map: rootState.gmaps.map,
      title: single.title,
      image: single.image,
      text: single.text,
      text_detail: single.text_detail,
      attachments: single.attachments,
      drawingId: single.drawingId,
      pinOpen: false,
      pinTypeId: single.pinTypeId,
      icon: iconFin,
      moreData: single.moreData,
      supportersCounter: single.supportersCounter,
      permissions: single.permissions,
      status: single.visible,
      comments: single.comments ? single.comments : [],
      optimized: false
    };
    if (single.line) {
      const polylines = [];
      if (Array.isArray(single.line) && single.line[0].lat) {
        polylines.push(
          createPolyline(rootState.gmaps, {
            path: single.line
          })
        );
      } else {
        Object.values(single.line).forEach((path) => {
          polylines.push(
            createPolyline(rootState.gmaps, {
              path: path
            })
          );
        });
      }

      markerDefinition.lines = polylines;
    }

    const marker = new Marker(markerDefinition);

    marker.addListener(`click`, () =>
      markerOnClickHandler(
        dispatch,
        marker,
        rootState.layers.layers[single.drawingId]
      )
    );

    commit('ADD_GM_LAYER_MARKERS', [marker]);
  },

  closeAllGmLayerMarkers({ commit }) {
    commit('CLOSE_ALL_GM_LAYER_MARKERS', []);
  },

  setGmLayerMarkerOpen({ commit }, markerId) {
    commit('SET_GM_LAYER_MARKER_OPEN', markerId);
  },

  newCluster({ commit }, [map, markers]) {
    let cluster = new MarkerClusterer(map, markers, {
      imagePath: '/vue/imgs/markerclusterer/m'
    });

    commit('NEW_CLUSTER', cluster);
  },

  reloadCluster({ commit }, [map, markers]) {
    let cluster = new MarkerClusterer(map, markers, {
      imagePath: '/vue/imgs/markerclusterer/m'
    });
    commit('RELOAD_CLUSTER', cluster);
  }
};

export const getters = {
  getMarkersByLayerID: (state) => (id) => {
    return state.markersLayered.filter((mark) => mark.drawingId === id);
  }
};
